import { render, staticRenderFns } from "./PublicacionNoticiaView.vue?vue&type=template&id=6d5701fc&scoped=true&"
import script from "./PublicacionNoticiaView.vue?vue&type=script&lang=ts&"
export * from "./PublicacionNoticiaView.vue?vue&type=script&lang=ts&"
import style0 from "./PublicacionNoticiaView.vue?vue&type=style&index=0&id=6d5701fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5701fc",
  null
  
)

export default component.exports